import React from 'react';
import PageHero from '../components/PageHero';
import BackButton from '../components/BackButton';
import Careers from '../components/Careers';

function CareersPage() {
  return (
    <>
      <PageHero
        label="Nexus Concordat"
        title="Careers"
        subtitle="Build what matters. With people who care."
      />
      <BackButton />
      <Careers />
    </>
  );
}

export default CareersPage;
